import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { FinancialConnection } from './financial-connection.entity';

export class CreateFinancialConnectionDto extends Omit(FinancialConnection, [...BaseEntityFieldsArray, 'status'], ['status']) {}
